import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheComuniApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useRegioniDataSource(nazioneId: string|undefined) {
    const api = new AnagraficheComuniApi(apiConfiguration);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            if (nazioneId)
              return api.getRegioni({ nazioneId: nazioneId });
            else
              return [];  
          },
    
          byKey: (key) => {
            return api.getRegioneById({
                regioneId: key
            });
          }
        });
      }, [nazioneId]);
    
      return dataSource;
}


